import { PortfolioPlanTags } from "@fartherfinance/frontend/api/Investment/types";
import { PortfolioTaxType } from "@fartherfinance/frontend/api/Types";

import { assertUnreachable } from "@src/utils/assertUnreachable";

const getTaxTypeFromTags = (
  tags: PortfolioPlanTags[]
): PortfolioTaxType | "DirectIndexedSleeve" => {
  if (tags.length === 0) {
    return "any";
  }

  const tag = tags[0];

  switch (tag) {
    case "Taxable":
      return "taxable";
    case "TaxExempt":
      return "tax_exempt";
    case "DirectIndexedSleeve":
      return "DirectIndexedSleeve";
    default:
      return assertUnreachable(tag);
  }
};

export default getTaxTypeFromTags;
